(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiks-sticky-navbar"] && !Shopify.designMode) return;
  try {
    
  class KiksStickyNavbar extends HTMLElement {
    constructor() {
      super();

      this.navItems = this.querySelectorAll('[data-nav-item]');
      this.enableSticky = this.dataset.enableSticky === 'true';
      this.mainContent = document.getElementById('MainContent');
      this.sections = [];
      this.triggerPoint = Number.POSITIVE_INFINITY;
      this.atcZoneTop = Number.POSITIVE_INFINITY;
      this.atcZoneBottom = Number.POSITIVE_INFINITY;
      this.hasCrossedAtcZone = false;
      this.lastScrollTop = window.pageYOffset;
      this.scrollDirectionThreshold = 6;
      this.resetHysteresis = 40;
      this.ticking = false;

      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      this.initSections();
      this.updateTriggerPoint();
      this.setupEventListeners();
      this.checkActiveSection();

      if (!this.enableSticky) {
        this.classList.remove('is-sticky');
        return;
      }

      this.handleStickyBehavior();
      window.addEventListener('resize', this.handleResize);
      setTimeout(() => {
        this.initSections();
        this.updateTriggerPoint();
        this.checkActiveSection();
        this.handleStickyBehavior();
      }, 500);
    }

    initSections() {
      if (!this.mainContent) return;

      const allSections = Array.from(this.mainContent.querySelectorAll('.shopify-section, [id^="shopify-section"]'));
      const uniqueSections = allSections.filter((section) => {
        const parent = section.parentElement.closest('.shopify-section, [id^="shopify-section"]');
        return !parent || parent === section;
      });

      uniqueSections.forEach((section, index) => {
        section.setAttribute('data-nav-section-index', index + 1);
      });

      this.sections = uniqueSections;
    }

    getTriggerElement() {
      const scopedMain = this.mainContent || document;

      const mainProductForm = scopedMain.querySelector("form[id^='product-form-'][id*='---MainSection']");
      if (mainProductForm) {
        return mainProductForm;
      }

      return (
        scopedMain.querySelector('button[id^="product-buy-btn-"][id*="---MainSection"]') ||
        scopedMain.querySelector('button[id^="product-buy-btn-"]') ||
        scopedMain.querySelector('.product-form__btn')
      );
    }

    updateTriggerPoint() {
      const triggerElement = this.getTriggerElement();
      if (!triggerElement) {
        this.triggerPoint = Number.POSITIVE_INFINITY;
        this.atcZoneTop = Number.POSITIVE_INFINITY;
        this.atcZoneBottom = Number.POSITIVE_INFINITY;
        this.hasCrossedAtcZone = false;
        return;
      }

      const top = this.getAbsoluteOffsetTop(triggerElement);
      const height = Math.max(triggerElement.offsetHeight || 0, triggerElement.getBoundingClientRect().height || 0);
      const bottom = top + height;

      this.atcZoneTop = top;
      this.atcZoneBottom = bottom;
      this.triggerPoint = bottom;

      // Keep state coherent on reload/resize when already below ATC zone.
      if (window.pageYOffset >= this.atcZoneBottom) {
        this.hasCrossedAtcZone = true;
      }
    }

    setupEventListeners() {
      this.navItems.forEach((item) => {
        item.addEventListener('click', () => {
          const requestedIndex = parseInt(item.getAttribute('data-section-index'), 10);
          const targetSection = this.sections[requestedIndex - 1];
          if (!targetSection) return;

          const navbarHeight = this.classList.contains('is-sticky') ? this.offsetHeight : 0;
          const targetPosition = this.getAbsoluteOffsetTop(targetSection) - navbarHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          this.setActiveItem(item, { smooth: true, forceCenter: true });
        });
      });

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleScroll() {
      if (this.ticking) return;

      window.requestAnimationFrame(() => {
        this.checkActiveSection();
        if (this.enableSticky) {
          this.handleStickyBehavior();
        }
        this.ticking = false;
      });

      this.ticking = true;
    }

    handleStickyBehavior() {
      const currentScroll = window.pageYOffset;
      const delta = currentScroll - this.lastScrollTop;

      let direction = 'none';
      if (delta > this.scrollDirectionThreshold) {
        direction = 'down';
      } else if (delta < -this.scrollDirectionThreshold) {
        direction = 'up';
      }

      const hasValidTrigger = Number.isFinite(this.atcZoneTop) && Number.isFinite(this.atcZoneBottom);
      if (!hasValidTrigger) {
        this.classList.remove('is-sticky');
        this.hasCrossedAtcZone = false;
        this.lastScrollTop = currentScroll;
        return;
      }

      // Reset latched state when user scrolls back above the ATC zone.
      if (currentScroll <= this.atcZoneTop - this.resetHysteresis) {
        this.hasCrossedAtcZone = false;
        this.classList.remove('is-sticky');
        this.lastScrollTop = currentScroll;
        return;
      }

      // Latch only when scrolling down and crossing the ATC zone bottom line.
      if (!this.hasCrossedAtcZone && direction === 'down' && currentScroll >= this.atcZoneBottom) {
        this.hasCrossedAtcZone = true;
      }

      if (!this.hasCrossedAtcZone) {
        this.classList.remove('is-sticky');
        this.lastScrollTop = currentScroll;
        return;
      }

      if (direction === 'up') {
        this.classList.remove('is-sticky');
      } else if (direction === 'down') {
        this.classList.add('is-sticky');
      }

      this.lastScrollTop = currentScroll;
    }

    getAbsoluteOffsetTop(element) {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    }

    handleResize() {
      window.requestAnimationFrame(() => {
        this.initSections();
        this.updateTriggerPoint();
        this.checkActiveSection();
        this.handleStickyBehavior();
      });
    }

    checkActiveSection() {
      if (!this.sections.length) return;

      const navbarHeight = this.classList.contains('is-sticky') ? this.offsetHeight : 0;
      const totalOffset = navbarHeight;
      const viewportHeight = window.innerHeight;
      const viewportBottom = window.scrollY + viewportHeight;

      const visibilityData = this.sections.map((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const sectionHeight = rect.height;
        const sectionBottom = sectionTop + sectionHeight;

        const visibleTop = Math.max(sectionTop, window.scrollY + totalOffset);
        const visibleBottom = Math.min(sectionBottom, viewportBottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibilityRatio = visibleHeight / sectionHeight;

        return {
          index,
          section,
          visibilityRatio,
          isInView: visibilityRatio > 0
        };
      });

      let mostVisibleSection = null;
      let maxVisibility = 0;

      visibilityData.forEach((data) => {
        if (data.isInView && data.visibilityRatio > maxVisibility) {
          maxVisibility = data.visibilityRatio;
          mostVisibleSection = data.section;
        }
      });

      if (window.scrollY <= 10) {
        mostVisibleSection = this.sections[0];
      }

      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 10) {
        mostVisibleSection = this.sections[this.sections.length - 1];
      }

      if (!mostVisibleSection) return;

      const sectionIndex = this.sections.indexOf(mostVisibleSection) + 1;
      const activeNavItem = Array.from(this.navItems).find(
        (item) => parseInt(item.getAttribute('data-section-index'), 10) === sectionIndex
      );

      if (activeNavItem) {
        this.setActiveItem(activeNavItem, { smooth: false, forceCenter: false });
      }
    }

    setActiveItem(activeItem, options = {}) {
      if (!activeItem) return;
      const { smooth = false, forceCenter = false } = options;

      this.navItems.forEach((item) => {
        if (item !== activeItem && item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      });

      if (activeItem.classList.contains('is-active')) return;

      activeItem.classList.add('is-active');
      const navbarContainer = this.querySelector('.kiks-sticky-navbar__items');
      if (!navbarContainer) return;

      const containerWidth = navbarContainer.offsetWidth;
      const itemWidth = activeItem.offsetWidth;
      const itemLeft = activeItem.offsetLeft;
      const currentScrollLeft = navbarContainer.scrollLeft;
      const itemVisibleLeft = itemLeft - currentScrollLeft;
      const itemVisibleRight = itemVisibleLeft + itemWidth;
      const isItemFullyVisible = itemVisibleLeft >= 0 && itemVisibleRight <= containerWidth;
      if (!forceCenter && isItemFullyVisible) return;
      const scrollLeft = itemLeft - containerWidth / 2 + itemWidth / 2;

      navbarContainer.scrollTo({
        left: scrollLeft,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  }

  if (!customElements.get('kiks-sticky-navbar')) {
    customElements.define('kiks-sticky-navbar', KiksStickyNavbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function (global) {
  var SIZES = [
    { value: "Twin", label: "Twin" },
    { value: "Full", label: "Full" },
    { value: "Queen", label: "Queen" },
    { value: "King", label: "King" },
    { value: "CLK", label: "Cal King" }
  ];

  function sizeLabel(size) {
    var hit = SIZES.find(function (s) { return s.value === size; });
    return hit ? hit.label : size;
  }

  function normSize(v) {
    if (!v) return "";
    var s = String(v).replace(/["']/g, "").trim().toLowerCase();
    if (s === "clk" || s === "cal king" || s === "california king" || s === "calking") return "CLK";
    if (s === "twin") return "Twin";
    if (s === "full") return "Full";
    if (s === "queen") return "Queen";
    if (s === "king") return "King";
    return String(v).trim();
  }

  function thickNum(v) {
    var m = String(v || "").match(/(\d+)/);
    return m ? m[1] : "";
  }

  function optionNames(product) {
    return (product.options || []).map(function (o) {
      return o.name.toLowerCase();
    });
  }

  function variantOpts(v) {
    return [v.option1, v.option2, v.option3].filter(Boolean);
  }

  function hasOpt(product, name) {
    return optionNames(product).indexOf(name) !== -1;
  }

  function findVariant(product, prefs) {
    var variants = product.variants || [];
    function match(strict) {
      return variants.filter(function (v) {
        if (!v.available) return false;
        var opts = variantOpts(v);
        if (hasOpt(product, "size")) {
          if (!opts.some(function (o) { return normSize(o) === normSize(prefs.size); })) return false;
        }
        if (strict && hasOpt(product, "thickness") && prefs.thickness) {
          if (!opts.some(function (o) { return thickNum(o) === thickNum(prefs.thickness); })) return false;
        }
        if (strict && hasOpt(product, "color") && prefs.color) {
          if (opts.indexOf(prefs.color) === -1) return false;
        }
        if (strict && hasOpt(product, "quantity") && prefs.quantity) {
          if (opts.indexOf(prefs.quantity) === -1) return false;
        }
        return true;
      });
    }
    var hit = match(true);
    if (hit.length) return hit[0];
    hit = match(false);
    return hit[0] || null;
  }

  function sizeAvailable(product, size) {
    if (!hasOpt(product, "size")) return true;
    return (product.variants || []).some(function (v) {
      return v.available && variantOpts(v).some(function (o) { return normSize(o) === normSize(size); });
    });
  }

  function thicknessesForSize(product, size) {
    if (!hasOpt(product, "thickness")) return [];
    var list = [];
    (product.variants || []).forEach(function (v) {
      if (!v.available) return;
      if (!variantOpts(v).some(function (o) { return normSize(o) === normSize(size); })) return;
      var t = variantOpts(v).find(function (o) { return thickNum(o); });
      if (t && list.indexOf(t) === -1) list.push(t);
    });
    return list;
  }

  function colorsForSize(product, size) {
    if (!hasOpt(product, "color")) return [];
    var list = [];
    (product.variants || []).forEach(function (v) {
      if (!v.available) return;
      if (!variantOpts(v).some(function (o) { return normSize(o) === normSize(size); })) return;
      var colorOpt = (product.options || []).find(function (o) { return o.name.toLowerCase() === "color"; });
      var color = variantOpts(v).find(function (o) { return colorOpt && colorOpt.values.indexOf(o) !== -1; });
      if (color && list.indexOf(color) === -1) list.push(color);
    });
    return list;
  }

  function quantities(product) {
    var opt = (product.options || []).find(function (o) { return o.name.toLowerCase() === "quantity"; });
    return opt ? opt.values.slice() : [];
  }

  function lineItemHtml(opts) {
    var img = opts.image
      ? '<div class="sn-bb__line-media"><img src="' +
        esc(opts.image) +
        '" alt="' +
        esc(opts.title) +
        '" loading="lazy" width="64" height="64"></div>'
      : '<div class="sn-bb__line-media" aria-hidden="true"></div>';
    return (
      "<li>" +
      img +
      '<div class="sn-bb__line-info"><span class="sn-bb__line-title">' +
      esc(opts.title) +
      "</span>" +
      (opts.meta ? '<span class="sn-bb__line-meta">' + esc(opts.meta) + "</span>" : "") +
      '</div><b class="sn-bb__line-price">' +
      esc(opts.priceLabel) +
      "</b></li>"
    );
  }

  function money(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function pickThickness(product, size, current) {
    var list = thicknessesForSize(product, size);
    if (!list.length) return "";
    if (current && list.some(function (t) { return thickNum(t) === thickNum(current); })) {
      return list.find(function (t) { return thickNum(t) === thickNum(current); });
    }
    return list.slice().sort(function (a, b) {
      return Number(thickNum(b) || 0) - Number(thickNum(a) || 0);
    })[0];
  }

  function pickColor(product, size, current) {
    var list = colorsForSize(product, size);
    if (!list.length) return "";
    if (current && list.indexOf(current) !== -1) return current;
    return list[0];
  }

  function pickQty(product, current) {
    var list = quantities(product);
    if (!list.length) return "";
    if (current && list.indexOf(current) !== -1) return current;
    return list.indexOf("Single Pack") !== -1 ? "Single Pack" : list[0];
  }

  function isUltra(product, ultraHandle) {
    return product.handle === (ultraHandle || "coolnest-ultra-memory-foam-mattress");
  }

  function SnBundleBuilder() {}

  SnBundleBuilder.init = function (el, catalog, options) {
    options = options || {};
    var state = {
      size: "Queen",
      mattressId: null,
      frameId: null,
      addonIds: {},
      thickness: {},
      color: {},
      quantity: {}
    };

    function products(role) {
      return catalog[role] || [];
    }

    function productById(id) {
      var all = products("mattress").concat(products("frame"), products("addon"));
      return all.find(function (p) { return String(p.id) === String(id); });
    }

    function prefsFor(product) {
      var pid = String(product.id);
      return {
        size: state.size,
        thickness: state.thickness[pid],
        color: state.color[pid],
        quantity: state.quantity[pid]
      };
    }

    function selectedLines() {
      var lines = [];
      if (state.mattressId) {
        var m = productById(state.mattressId);
        var mv = m && findVariant(m, prefsFor(m));
        if (m && mv) lines.push({ role: "mattress", product: m, variant: mv });
      }
      if (state.frameId) {
        var f = productById(state.frameId);
        var fv = f && findVariant(f, prefsFor(f));
        if (f && fv) lines.push({ role: "frame", product: f, variant: fv });
      }
      Object.keys(state.addonIds).forEach(function (id) {
        if (!state.addonIds[id]) return;
        var a = productById(id);
        var av = a && findVariant(a, prefsFor(a));
        if (a && av) lines.push({ role: "addon", product: a, variant: av });
      });
      return lines;
    }

    // Match Shopify % automatic discounts: discount cents = floor(price * percent / 100) per line ("each")
    function shopifyPercentOff(cents, rate) {
      cents = Number(cents) || 0;
      if (!rate || cents <= 0) return cents;
      var percent = Math.round(rate * 100);
      var discount = Math.floor((cents * percent) / 100);
      return cents - discount;
    }

    function promo() {
      return catalog.promo || {};
    }

    function pctRate(n, fallback) {
      var v = Number(n);
      if (!isFinite(v)) v = fallback;
      return (v || 0) / 100;
    }

    function isSoloEligible(product) {
      var p = promo();
      if (!p.soloEnabled || !product) return false;
      var handles = p.soloHandles || [];
      if (!handles.length) return false;
      return handles.indexOf(product.handle) !== -1;
    }

    function ruleSummaryHtml() {
      var p = promo();
      var pair = p.pairPercent != null ? p.pairPercent : 15;
      var triple = p.triplePercent != null ? p.triplePercent : 20;
      var solo = p.soloPercent != null ? p.soloPercent : 10;
      var parts = [];
      if (p.soloEnabled && (p.soloHandles || []).length) {
        parts.push("eligible mattress alone = " + solo + "%");
      } else {
        parts.push("no solo mattress discount");
      }
      parts.push("Buy 2 = " + pair + "%");
      parts.push("Buy 3+ = " + triple + "%");
      return parts.join(" · ") + ". Only one tier applies — discounts do not stack.";
    }

    function totals() {
      var lines = selectedLines();
      var sub = 0;
      var compare = 0;
      lines.forEach(function (l) {
        sub += l.variant.price;
        compare += l.variant.compare || l.variant.price;
      });
      // Free gifts ($0) do not count toward Buy 2 / Buy 3 tiers
      var paid = lines.filter(function (l) { return (l.variant.price || 0) > 0; }).length;
      var mattress = state.mattressId ? productById(state.mattressId) : null;
      var mattressSolo = paid === 1 && !!mattress;
      var p = promo();
      var pairRate = pctRate(p.pairPercent, 15);
      var tripleRate = pctRate(p.triplePercent, 20);
      var soloRate = pctRate(p.soloPercent, 10);
      // Exclusive tiers (preview only, do not stack). Solo % only for configured eligible mattresses.
      var rate = 0;
      var tier = null;
      if (paid >= 3) {
        rate = tripleRate;
        tier = "triple";
      } else if (paid >= 2) {
        rate = pairRate;
        tier = "pair";
      } else if (mattressSolo && isSoloEligible(mattress)) {
        rate = soloRate;
        tier = "mattress";
      }
      var extra = rate > 0;
      var preview = sub;
      if (extra) {
        preview = 0;
        lines.forEach(function (l) {
          preview += shopifyPercentOff(l.variant.price, rate);
        });
      }
      return {
        lines: lines,
        sub: sub,
        compare: compare,
        paid: paid,
        extra: extra,
        rate: rate,
        tier: tier,
        mattressSolo: mattressSolo,
        preview: preview
      };
    }

    function dealNoteHtml(t) {
      var p = promo();
      var pairPct = p.pairPercent != null ? p.pairPercent : 15;
      var triplePct = p.triplePercent != null ? p.triplePercent : 20;
      var soloPct = p.soloPercent != null ? p.soloPercent : 10;
      var noStack = '<p class="sn-bb__hint">Discounts do not stack — only the highest qualifying tier applies at checkout.</p>';
      if (t.tier === "triple") {
        return (
          '<p class="sn-bb__deal">Preview Bundle &amp; Save ' +
          triplePct +
          "% · <b>" +
          money(t.preview) +
          "</b> · checkout is final</p>" +
          noStack
        );
      }
      if (t.tier === "pair") {
        return (
          '<p class="sn-bb__deal">Preview ' +
          pairPct +
          "% OFF · <b>" +
          money(t.preview) +
          "</b> · checkout is final</p>" +
          '<p class="sn-bb__hint">Add 1 more paid item to upgrade to Bundle &amp; Save ' +
          triplePct +
          "% OFF (replaces " +
          pairPct +
          "%, does not stack).</p>"
        );
      }
      if (t.tier === "mattress") {
        return (
          '<p class="sn-bb__deal">Preview mattress ' +
          soloPct +
          "% OFF · <b>" +
          money(t.preview) +
          "</b> · checkout is final</p>" +
          '<p class="sn-bb__hint">Add paid items to upgrade: Buy 2 → ' +
          pairPct +
          "%, Buy 3+ → " +
          triplePct +
          "%. Higher tier replaces " +
          soloPct +
          "% — does not stack.</p>"
        );
      }
      if (state.mattressId) {
        return (
          '<p class="sn-bb__hint">Add a frame, sheets, or pillow to upgrade (Buy 2 = ' +
          pairPct +
          "%, Buy 3+ = " +
          triplePct +
          "%). Tiers do not stack. Gift pillows do not count.</p>"
        );
      }
      return '<p class="sn-bb__hint">Select a mattress to start. ' + ruleSummaryHtml() + "</p>";
    }

    function atcLabel(btn) {
      if (!state.mattressId) return "Select a mattress";
      var t = totals();
      var payable = t.extra ? t.preview : t.sub;
      var isSticky = btn && btn.hasAttribute("data-bb-sticky-atc");
      // PC summary ATC: put preview price on the button (no black deal bar on desk)
      if (!isSticky) return "Add to cart · " + money(payable);
      return "Add to cart";
    }

    function updateStickyCompare(t) {
      var cmp = el.querySelector("[data-bb-sticky-compare]");
      if (!cmp) return;
      if (t.compare > t.sub || (t.extra && t.compare > t.preview)) {
        cmp.textContent = money(t.compare);
        cmp.hidden = false;
        cmp.classList.add("is-on");
      } else {
        cmp.textContent = "";
        cmp.hidden = true;
        cmp.classList.remove("is-on");
      }
    }

    function renderCard(product, role) {
      if (!sizeAvailable(product, state.size)) return "";
      var pid = String(product.id);
      var thicks = thicknessesForSize(product, state.size);
      var colors = colorsForSize(product, state.size);
      var qtys = quantities(product);
      if (thicks.length) state.thickness[pid] = pickThickness(product, state.size, state.thickness[pid]);
      if (colors.length) state.color[pid] = pickColor(product, state.size, state.color[pid]);
      if (qtys.length) state.quantity[pid] = pickQty(product, state.quantity[pid]);
      var variant = findVariant(product, prefsFor(product));
      if (!variant) return "";
      var selected =
        (role === "mattress" && String(state.mattressId) === pid) ||
        (role === "frame" && String(state.frameId) === pid) ||
        (role === "addon" && state.addonIds[pid]);
      var ultra = isUltra(product, catalog.ultraHandle);
      var tags = "";
      if (role === "mattress" && isSoloEligible(product)) {
        var badge = (promo().soloBadge || "10% Off alone").trim();
        if (badge) tags += '<span class="tag primary">' + esc(badge) + "</span>";
      }

      var extraPills = "";
      if (thicks.length) {
        extraPills += '<div class="sn-bb__opt"><span class="sn-bb__opt-label">Choose your thickness</span><div class="sn-bb__pills" data-kind="thickness" data-id="' + pid + '">';
        thicks.forEach(function (t) {
          extraPills += '<button type="button" class="sn-bb__mini' + (thickNum(state.thickness[pid]) === thickNum(t) ? " is-on" : "") + '" data-val="' + esc(t) + '">' + esc(t.replace(/'/g, '"')) + "</button>";
        });
        extraPills += "</div></div>";
      }
      if (colors.length) {
        extraPills += '<div class="sn-bb__opt"><span class="sn-bb__opt-label">Choose your color</span><div class="sn-bb__pills" data-kind="color" data-id="' + pid + '">';
        colors.forEach(function (c) {
          extraPills += '<button type="button" class="sn-bb__mini' + (state.color[pid] === c ? " is-on" : "") + '" data-val="' + esc(c) + '">' + esc(c) + "</button>";
        });
        extraPills += "</div></div>";
      }
      if (qtys.length) {
        extraPills += '<div class="sn-bb__opt"><span class="sn-bb__opt-label">Choose your quantity</span><div class="sn-bb__pills" data-kind="quantity" data-id="' + pid + '">';
        qtys.forEach(function (q) {
          extraPills += '<button type="button" class="sn-bb__mini' + (state.quantity[pid] === q ? " is-on" : "") + '" data-val="' + esc(q) + '">' + esc(q) + "</button>";
        });
        extraPills += "</div></div>";
      }

      var save = (variant.compare || 0) > variant.price ? variant.compare - variant.price : 0;
      var priceBlock =
        '<div class="price-row"><span class="price">' +
        money(variant.price) +
        "</span>" +
        (variant.compare > variant.price ? '<span class="compare">' + money(variant.compare) + "</span>" : "") +
        (save ? '<span class="save">SAVE ' + money(save) + "</span>" : "") +
        "</div>";

      return (
        '<article class="kik-card sn-bb__card' +
        (selected ? " is-selected" : "") +
        '" data-role="' +
        role +
        '" data-id="' +
        pid +
        '">' +
        '<div class="kik-card__media"><img src="' +
        esc(product.image) +
        '" alt="' +
        esc(product.title) +
        '"><div class="kik-card__tags">' +
        tags +
        "</div></div>" +
        '<div class="kik-card__body"><h3>' +
        esc(product.title) +
        "</h3><p class=\"sn-bb__size\">Size: " +
        esc(sizeLabel(state.size)) +
        "</p>" +
        extraPills +
        priceBlock +
        '<button type="button" class="btn sn-bb__pick">' +
        (selected ? "Selected" : role === "mattress" ? "Select mattress" : "Add") +
        "</button></div></article>"
      );
    }

    function render() {
      var t = totals();
      var sizeBtns = SIZES.map(function (s) {
        return (
          '<button type="button" class="sn-bb__size-btn' +
          (state.size === s.value ? " is-on" : "") +
          '" data-size="' +
          s.value +
          '">' +
          s.label +
          "</button>"
        );
      }).join("");

      var lineHtml = t.lines
        .map(function (l) {
          var linePrice = t.extra ? shopifyPercentOff(l.variant.price, t.rate) : l.variant.price;
          return lineItemHtml({
            title: l.product.title,
            meta: l.variant.title,
            image: l.product.image,
            priceLabel: money(linePrice)
          });
        })
        .join("");

      var payable = t.extra ? t.preview : t.sub;

      el.querySelectorAll("[data-bb-sizes-desk], [data-bb-sizes-mobi]").forEach(function (node) {
        node.innerHTML = sizeBtns;
      });
      el.querySelector("[data-bb-mattress]").innerHTML = products("mattress").map(function (p) { return renderCard(p, "mattress"); }).join("");
      el.querySelector("[data-bb-frame]").innerHTML = products("frame").map(function (p) { return renderCard(p, "frame"); }).join("");
      el.querySelector("[data-bb-addon]").innerHTML = products("addon").map(function (p) { return renderCard(p, "addon"); }).join("");
      el.querySelector("[data-bb-lines]").innerHTML = lineHtml || "<li>No items yet</li>";
      el.querySelector("[data-bb-count]").textContent = String(t.paid);
      el.querySelector("[data-bb-sub]").textContent = money(t.sub);
      el.querySelector("[data-bb-compare]").textContent = t.compare > t.sub ? money(t.compare) : "";
      el.querySelector("[data-bb-note]").innerHTML = dealNoteHtml(t);
      var atcButtons = el.querySelectorAll("[data-bb-atc]");
      atcButtons.forEach(function (atc) {
        atc.disabled = !state.mattressId;
        atc.textContent = atcLabel(atc);
      });
      el.querySelector("[data-bb-sticky-total]").textContent = money(payable);
      updateStickyCompare(t);
    }

    function onSize(size) {
      state.size = size;
      if (state.mattressId) {
        var m = productById(state.mattressId);
        if (!m || !sizeAvailable(m, size)) state.mattressId = null;
        else state.thickness[String(m.id)] = pickThickness(m, size, state.thickness[String(m.id)]);
      }
      if (state.frameId) {
        var f = productById(state.frameId);
        if (!f || !sizeAvailable(f, size)) state.frameId = null;
        else state.color[String(f.id)] = pickColor(f, size, state.color[String(f.id)]);
      }
      Object.keys(state.addonIds).forEach(function (id) {
        var a = productById(id);
        if (a && hasOpt(a, "size") && !sizeAvailable(a, size)) delete state.addonIds[id];
      });
      render();
    }

    function toggle(role, id) {
      var product = productById(id);
      if (!product || !findVariant(product, prefsFor(product))) return;
      if (role === "mattress") {
        state.mattressId = id;
      } else if (role === "frame") {
        state.frameId = id;
      } else {
        if (state.addonIds[id]) delete state.addonIds[id];
        else state.addonIds[id] = true;
      }
      render();
    }

    el.addEventListener("click", function (e) {
      if (e.target.closest("[data-bb-atc]")) {
        addToCart();
        return;
      }
      var accordionToggle = e.target.closest("[data-bb-toggle]");
      if (accordionToggle) {
        if (window.matchMedia("(min-width: 768px)").matches) return;
        var step = accordionToggle.closest(".sn-bb__step");
        if (!step) return;
        var open = !step.classList.contains("is-open");
        step.classList.toggle("is-open", open);
        accordionToggle.setAttribute("aria-expanded", open ? "true" : "false");
        return;
      }
      var sizeBtn = e.target.closest("[data-size]");
      if (sizeBtn) {
        onSize(sizeBtn.getAttribute("data-size"));
        return;
      }
      var mini = e.target.closest(".sn-bb__mini");
      if (mini) {
        e.stopPropagation();
        var wrap = mini.closest(".sn-bb__pills");
        if (!wrap) return;
        var id = wrap.getAttribute("data-id");
        var kind = wrap.getAttribute("data-kind");
        var val = mini.getAttribute("data-val");
        if (kind === "thickness") state.thickness[id] = val;
        if (kind === "color") state.color[id] = val;
        if (kind === "quantity") state.quantity[id] = val;
        render();
        return;
      }
      var card = e.target.closest(".sn-bb__card[data-role][data-id]");
      if (card && !card.classList.contains("is-disabled")) {
        toggle(card.getAttribute("data-role"), card.getAttribute("data-id"));
      }
    });

    function resetAtc(label) {
      var atcButtons = el.querySelectorAll("[data-bb-atc]");
      atcButtons.forEach(function (atc) {
        atc.disabled = !state.mattressId;
        atc.textContent = label || atcLabel(atc);
      });
    }

    function openLiveCart(parsedState) {
      var drawer = document.querySelector("cart-drawer");
      var sectionId =
        (drawer && (drawer.getAttribute("data-section-id") || drawer.dataset.sectionId)) ||
        "";
      var sectionHtml =
        parsedState &&
        parsedState.sections &&
        sectionId &&
        parsedState.sections[sectionId]
          ? parsedState.sections[sectionId]
          : null;

      if (drawer && sectionHtml && typeof drawer.purchaseHandler === "function") {
        var doc = new DOMParser().parseFromString(sectionHtml, "text/html");
        if (typeof drawer.updateAsideProductsByParsedState === "function") {
          try {
            drawer.updateAsideProductsByParsedState(parsedState);
          } catch (e) {}
        }
        if (typeof drawer.updateEmptyStatus === "function") {
          try {
            drawer.updateEmptyStatus();
          } catch (e) {}
        }
        return Promise.resolve(drawer.purchaseHandler(doc, parsedState));
      }

      if (drawer && typeof drawer.update === "function") {
        try {
          drawer.update();
        } catch (e) {}
      }
      if (drawer && typeof drawer.open === "function") {
        return Promise.resolve(drawer.open());
      }

      var popup = document.querySelector("cart-notification-popup");
      if (popup && sectionHtml && typeof popup.purchaseHandler === "function") {
        var popupDoc = new DOMParser().parseFromString(sectionHtml, "text/html");
        popup.purchaseHandler(popupDoc, parsedState);
        return Promise.resolve();
      }

      return Promise.reject(new Error("Cart drawer unavailable"));
    }

    function addToCart() {
      var t = totals();
      if (!t.lines.length) return;
      var items = t.lines.map(function (l) {
        return { id: l.variant.id, quantity: 1, properties: { _bundle: "labor-day" } };
      });
      var atcButtons = el.querySelectorAll("[data-bb-atc]");
      atcButtons.forEach(function (atc) {
        atc.disabled = true;
        atc.textContent = "Adding…";
      });
      if (options.prototype) {
        resetAtc();
        var msg = t.lines
          .map(function (l) {
            return l.product.title + " — " + l.variant.title + " (" + l.variant.id + ") " + money(l.variant.price);
          })
          .join("\n");
        var _p = promo();
        var _pair = _p.pairPercent != null ? _p.pairPercent : 15;
        var _triple = _p.triplePercent != null ? _p.triplePercent : 20;
        var _solo = _p.soloPercent != null ? _p.soloPercent : 10;
        window.alert(
          "Prototype only — would POST /cart/add.js\n\n" +
            msg +
            (t.tier === "triple"
              ? "\n\nPreview Bundle & Save " + _triple + "% — highest tier only, does not stack (checkout applies the real discount)."
              : t.tier === "pair"
                ? "\n\nPreview " + _pair + "% OFF — does not stack with solo mattress discount (checkout applies the real discount)."
                : t.tier === "mattress"
                  ? "\n\nPreview mattress " + _solo + "% OFF — upgrades replace this tier, do not stack (checkout applies the real discount)."
                  : "")
        );
        return;
      }

      var drawer = document.querySelector("cart-drawer");
      var sectionId =
        (drawer && (drawer.getAttribute("data-section-id") || drawer.dataset.sectionId)) ||
        "";
      var payload = { items: items };
      if (sectionId) {
        payload.sections = sectionId;
        payload.sections_url = window.location.pathname;
      }

      var addUrl =
        (window.routes && window.routes.cart_add_url) || "/cart/add.js";
      if (addUrl.indexOf(".js") === -1 && addUrl.indexOf("sections") === -1) {
        // Theme route is usually /cart/add; keep JSON endpoint for multi-item + sections.
        addUrl = "/cart/add.js";
      }

      fetch(addUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          return openLiveCart(data).then(function () {
            resetAtc();
            document.dispatchEvent(
              new CustomEvent("cart:updated", { detail: { cart: data } })
            );
          });
        })
        .catch(function (err) {
          resetAtc();
          var desc =
            (err && (err.description || err.message)) ||
            "Could not add to cart. Try another size or item.";
          window.alert(desc);
        });
    }

    render();
    bindStickyRevealFrom(el);
    bindBundleJumpNav(el);
  };

  function bindBundleJumpNav(root) {
    if (!root || root.getAttribute("data-bb-jump-nav") === "1") return;
    root.setAttribute("data-bb-jump-nav", "1");

    var bundleNav = root.querySelector("[data-sn-bundle-nav]") || document.querySelector("[data-sn-bundle-nav]");
    if (!bundleNav) return;
    if (bundleNav.parentElement !== document.body) {
      document.body.appendChild(bundleNav);
    }

    var bundleStart =
      document.getElementById("sn-buy-any-2") ||
      document.querySelector("[data-sn-buy-any-2]") ||
      document.querySelector(".sn-dp-mod--bundle") ||
      root.querySelector(".sn-bb__steps") ||
      root;

    function stickyTopPx() {
      var header = document.querySelector(".shopify-section-header") || document.getElementById("header-component");
      if (header) {
        var bottom = header.getBoundingClientRect().bottom;
        if (bottom > 0) return Math.round(bottom);
      }
      return 56;
    }

    function syncStickyTop() {
      var top = stickyTopPx();
      document.documentElement.style.setProperty("--sn-deal-sticky-top", top + "px");
      bundleNav.style.top = top + "px";
      if (bundleNav.classList.contains("is-on")) {
        document.documentElement.style.setProperty(
          "--sn-deal-bundle-nav-h",
          Math.round(bundleNav.getBoundingClientRect().height || 48) + "px"
        );
      }
    }

    function scrollToStep(step) {
      syncStickyTop();
      var top = stickyTopPx();
      var navH = bundleNav.classList.contains("is-on") ? bundleNav.getBoundingClientRect().height : 48;
      var y = window.scrollY + step.getBoundingClientRect().top - top - navH - 8;
      window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
    }

    function headerMenuOpen() {
      var header = document.getElementById("header-component");
      if (!header) return false;
      if (header.hasAttribute("data-sn-panel")) return true;
      var menu = document.getElementById("HeaderDropdownMenu");
      if (menu && menu.getAttribute("aria-hidden") === "false") return true;
      if (header.querySelector('[aria-expanded="true"], [data-aria-expanded="true"]')) return true;
      return false;
    }

    function gotoStep(key) {
      var step = root.querySelector('[data-bb-step="' + key + '"]');
      if (!step) return;
      var isMobi = window.matchMedia("(max-width: 767px)").matches;
      if (isMobi) {
        root.querySelectorAll('[data-bb-step="mattress"], [data-bb-step="frame"], [data-bb-step="addon"]').forEach(function (s) {
          var open = s.getAttribute("data-bb-step") === key;
          s.classList.toggle("is-open", open);
          var t = s.querySelector("[data-bb-toggle]");
          if (t) t.setAttribute("aria-expanded", open ? "true" : "false");
        });
      } else {
        step.classList.add("is-open");
        var deskToggle = step.querySelector("[data-bb-toggle]");
        if (deskToggle) deskToggle.setAttribute("aria-expanded", "true");
      }
      bundleNav.querySelectorAll("[data-sn-goto]").forEach(function (b) {
        b.classList.toggle("is-on", b.getAttribute("data-sn-goto") === key);
      });
      bundleNav.hidden = false;
      bundleNav.classList.add("is-on");
      syncStickyTop();
      requestAnimationFrame(function () {
        scrollToStep(step);
      });
    }

    bundleNav.addEventListener("click", function (e) {
      var gotoBtn = e.target.closest("[data-sn-goto]");
      if (!gotoBtn) return;
      e.preventDefault();
      gotoStep(gotoBtn.getAttribute("data-sn-goto"));
    });

    function updateChrome() {
      syncStickyTop();
      var y = window.scrollY || window.pageYOffset || 0;
      document.body.classList.toggle("sn-deal-scrolled", y > 8);

      bundleNav.hidden = false;
      var top = stickyTopPx();
      var startTop = bundleStart.getBoundingClientRect().top;
      var show = startTop <= top + 12;
      if (root.getBoundingClientRect().bottom <= top + 8) show = false;
      var underHeader = window.matchMedia("(min-width: 768px)").matches && headerMenuOpen();
      bundleNav.classList.toggle("is-on", show && !underHeader);
      bundleNav.classList.toggle("is-under-header", underHeader);
      if (show && !underHeader) syncStickyTop();

      if (show && !underHeader) {
        var active = null;
        var probe = top + (bundleNav.getBoundingClientRect().height || 48) + 24;
        ["mattress", "frame", "addon"].forEach(function (key) {
          var el = root.querySelector('[data-bb-step="' + key + '"]');
          if (!el) return;
          if (el.getBoundingClientRect().top <= probe) active = key;
        });
        if (active) {
          bundleNav.querySelectorAll("[data-sn-goto]").forEach(function (b) {
            b.classList.toggle("is-on", b.getAttribute("data-sn-goto") === active);
          });
        }
      }
    }

    window.addEventListener("scroll", updateChrome, { passive: true });
    window.addEventListener("resize", updateChrome);
    document.addEventListener("mouseover", function (e) {
      if (e.target && e.target.closest && e.target.closest("#header-component, .shopify-section-header")) {
        updateChrome();
      }
    });
    document.addEventListener("mouseout", function (e) {
      if (e.target && e.target.closest && e.target.closest("#header-component, .shopify-section-header")) {
        updateChrome();
      }
    });
    var headerRoot = document.getElementById("header-component");
    if (headerRoot && window.MutationObserver) {
      new MutationObserver(updateChrome).observe(headerRoot, {
        attributes: true,
        attributeFilter: ["data-sn-panel", "class"],
        subtree: true
      });
    }
    updateChrome();
  }

  function bindStickyRevealFrom(root) {
    var sticky = root.querySelector("[data-bb-sticky]");
    if (!sticky || !sticky.classList.contains("sn-bb__sticky--gated")) return;

    function triggerEl() {
      return (
        document.getElementById("sn-buy-any-2") ||
        document.querySelector("[data-sn-buy-any-2]") ||
        document.querySelector(".sn-dp-mod--bundle") ||
        root.querySelector('[data-bb-step="mattress"]') ||
        root
      );
    }

    function update() {
      var trigger = triggerEl();
      if (!trigger) {
        sticky.classList.add("is-on");
        root.classList.add("has-sticky-on");
        return;
      }
      var top = trigger.getBoundingClientRect().top;
      var show = top <= window.innerHeight * 0.82;
      sticky.classList.toggle("is-on", show);
      root.classList.toggle("has-sticky-on", show);
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      update();
      if (document.getElementById("sn-buy-any-2") || tries > 20) clearInterval(timer);
    }, 250);
  }

  global.SnBundleBuilder = SnBundleBuilder;

  function boot(root) {
    if (!root || root.getAttribute("data-bb-booted")) return;
    var script = root.querySelector("script[data-bb-catalog]");
    if (!script) return;
    var catalog;
    try {
      catalog = JSON.parse(script.textContent);
    } catch (err) {
      console.error("SN bundle catalog JSON", err);
      return;
    }
    root.setAttribute("data-bb-booted", "1");
    document.body.classList.add("sn-bb-page");
    SnBundleBuilder.init(root, catalog, {});
  }

  function bootAll() {
    document.querySelectorAll("[data-sn-bb]").forEach(boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector("[data-sn-bb]")
      : null;
    if (!root && e.target && e.target.getAttribute && e.target.getAttribute("data-sn-bb") != null) {
      root = e.target;
    }
    boot(root);
  });
})(typeof window !== "undefined" ? window : this);


  } catch(e) { console.error(e); }
})();
})();
